import React from 'react'
import { isMobile } from '../../../../utils';
import { Button } from 'antd';
import "./course-btn.scss"

const CourseBtn = ({userInfo, sectionCourse, isTeacher, setFeedbackVisible, setScoreVisible}) => {
    if (isMobile()) {
        return <div className='course-btn'>
            {userInfo.campus_id &&
                !sectionCourse?.campus &&
                isTeacher && (
                    <div className="btns">
                    <Button
                        className="btn"
                        type="primary"
                        size="large"
                        onClick={() => {
                        setFeedbackVisible(true);
                        }}
                    >
                        课程反馈
                    </Button>

                    <Button
                        className="btn"
                        type="primary"
                        size="large"
                        onClick={() => {
                        setScoreVisible(true);
                        }}
                    >
                        课程评分
                    </Button>
                    </div>
                )}
        </div>
    } else {
        return null
    }
}

export default CourseBtn